import { Injectable } from '@angular/core';
import { DatastoreService } from './datastore.service';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable, Subject, Subscription, timer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  booking: any;
  isPlaying: boolean;
  public newMessage: Subject<any> = new Subject<any>();

  constructor(
    private dataStore: DatastoreService,
    private api: ApiService
  ) { }

  pollForMessages() {
    if (!this.booking) {
      const bookingStr = localStorage.getItem('ceremony') as string;
      this.booking = JSON.parse(bookingStr);
    }
    if (this.dataStore.member) {
      setInterval(async () => {
        if (!this.dataStore.activeThread) {
          const activeThreadStr = sessionStorage.getItem('active_thread') as any;
          if (activeThreadStr && activeThreadStr.length > 0) {
            this.dataStore.activeThread = JSON.parse(activeThreadStr);
            const messagesStr = sessionStorage.getItem('active_thread_messages') as any;
            if (messagesStr && messagesStr.length > 0) {
              this.dataStore.messagesOnActiveThread = JSON.parse(messagesStr);
            }
          }
        }
        console.log(this.dataStore.activeThread, this.booking);
        if (this.dataStore.activeThread && this.booking) {
          console.log(`Polling for new messages on thread ${this.dataStore.activeThread.thread_id}`);
          const messages:any = await this.api.getMessagesInThread(this.booking.company_id, this.dataStore.activeThread.thread_id, true);
          for (const message of messages) {
            const found = this.dataStore.messagesOnActiveThread.find((m:any) => m.message_id === message.message_id);
            if (!found) {
              console.log(`New message! ${message.message_id}`);
              this.dataStore.messagesOnActiveThread.unshift(message);
              // Only play ONCE per poll
              if (!this.isPlaying) {
                this.isPlaying = true;
                this.playNewMessageAudio();
              }
              this.newMessage.next(message);
            }
          }
          // reset play loop
          this.isPlaying = false;
        } 
      }, 3000);
    }
  }

  playNewMessageAudio(){
    try {
      let audio = new Audio();
      audio.src = "../assets/audio/new_message.mp3";
      audio.load();
      audio.play();
    }
    catch (err) {
      console.log(err);
    }
  }
}
